import HotelCardFeatures from './HotelCardFeatures';

export default HotelCardFeatures;
